import { render, staticRenderFns } from "./Application-certification.vue?vue&type=template&id=7dadedf4&scoped=true&"
import script from "./Application-certification.vue?vue&type=script&lang=js&"
export * from "./Application-certification.vue?vue&type=script&lang=js&"
import style0 from "./Application-certification.vue?vue&type=style&index=0&id=7dadedf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dadedf4",
  null
  
)

export default component.exports